<template>
  <div>
    <st_header_cop :default_index11="'1'"> </st_header_cop>

    <div class="index_page contanic_no_lock">
      <div class="content_div">
        <img src="../assets/ab_main.jpg" alt="" width="100%" height="auto" />
      </div>
    </div>

    <st_footer_cop :active-index="'1'" :is_lock_infeed="false"> </st_footer_cop>
  </div>
</template>

<script>
import st_header from "../components/header_thr_about.vue";
import st_footer from "../components/footer.vue";

export default {
  name: "about-about",
  components: {
    st_header_cop: st_header,
    st_footer_cop: st_footer,
  },
  data() {
    return {
      img_url: this.GLOBALS.ossServer + "about_img/01.jpg",
    };
  },
};
</script>

<style scoped lang="scss">
.contanic_no_lock {
  padding-top: 80px;
  height: auto;
  min-height: 70vh;
}

.index_page {
  // background: rgba(255, 255, 255, 1);
  margin-left: 0px;
  margin-right: 0px;
}

.content_div {
  text-align: center;
  position: relative;
}
.div_001 {
  position: absolute;
  z-index: 10000;
  width: 100%;
  text-align: center;
  overflow: hidden;
  height: auto;
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/view/th_about.vue